import React from 'react';
import { observer } from 'mobx-react';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

const FauxSelect = observer(class FauxSelect extends React.Component {
  constructor() {
    super();
    this.checkKey = this.checkKey.bind(this);
    this.showFauxSelect = this.showFauxSelect.bind(this);
    this.hideFauxSelect = this.hideFauxSelect.bind(this);
  }

  componentWillMount() {
    this.state = {
      default: this.props.default || 'Select…',
      highlighted: -1,
      showing: false
    }

    // Make sure we’re not duplicating the event listener
    document.removeEventListener('keydown', this.checkKey);

    // We need to add an event listener to allow using the up and down arrows
    // to move through the select options
    document.addEventListener('keydown', this.checkKey);
  }

  componentWillUnmount() {
    // Remove the event listener when the select element is destroyed
    document.removeEventListener('keydown', this.checkKey);
  }

  componentDidMount() {
    // const dropdowns = document.querySelectorAll('.dropdown, .dropdown__content');
    // dropdowns.forEach(function(dropdown){
    //   if(dropdown) {
    //     dropdown.setAttribute('tabindex', '0');
    //   }
    // });
  }

  clickOption(e, index) {
    const { onClick, parent, skipText } = this.props;

    // Unless otherwise specified, update the text of the dropdown selection
    if(!skipText) {
      this.setState({
        default: e.target.getAttribute('data-label')
      });
    }

    if(parent) {
      parent.setState({
        action: e.target.getAttribute('data-action')
      })
    }

    if(onClick) {
      onClick(e, this.props, index);
    }

    // Hide the options
    const dropdowns = [];
    dropdowns.push(this.refs.fauxSelect);
    for(var i = 0; i < dropdowns.length; i++) {
      if(typeof dropdowns[i] !== 'undefined') {
        dropdowns[i].hide();
      }
    }
  }

  renderTooltip(key) {
    if(key.helper) {
      return (
        <div className="tooltip tooltip--right" onClick={(e) => {e.stopPropagation()}}>
          <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
          <div id={`${key.action}-tooltip`} className="tooltip__body" role="tooltip">
            {key.helper}
          </div>
        </div>
      );
    }

    return '';
  }

  checkKey(e) {
    // Prevent scrolling when up or down key are pressed
    if(this.state.showing && (e.keyCode === 40 || e.keyCode === 38)) {
      e.preventDefault();
    }

    if(this.state.showing && (e.keyCode === 40 || e.keyCode === 38 || (e.keyCode === 9 && !e.shiftKey))) {
      // Down key or tab key
      if((e.keyCode === 40 || e.keyCode === 9) && this.state.highlighted < this.props.options.length - 1) {
        e.preventDefault();

        this.setState({
          highlighted: this.state.highlighted + 1
        });
      } else if(e.keyCode === 9 && !e.shiftKey && this.state.highlighted >= this.props.options.length - 1) {
        // If tabbing through and at the end, hide the dropdown
        this.refs.fauxSelect.hide();
      }

      // Up key or shift + tab key
      if((e.keyCode === 38 || (e.keyCode === 9 && e.shiftKey)) && this.state.highlighted > 0) {
        e.preventDefault();

        this.setState({
          highlighted: this.state.highlighted - 1
        });
      }

      // Focus the button with the highlighted index
      if(this.refs[`option-${this.state.highlighted}`]) {
        this.refs[`option-${this.state.highlighted}`].focus();
      }
    }
  }

  showFauxSelect(e) {
    this.setState({
      showing: true
    });

    if(e && e.target) {
      const options = e.target.querySelector('.faux-select__options');
      const footer = document.querySelector('.site-foot');

      if(options) {
        const docHeight = document.body.clientHeight;
        const footerHeight = footer.clientHeight;
        const optionsHeight = options.clientHeight;
        const optionsTop = this.topOffset(options);

        if(
          (docHeight - footerHeight) - (optionsTop + optionsHeight) < 150 &&
          options.className.indexOf('bottom') < 0
        ) {
          options.className += ' bottom';
        }
      }
    }
  }

  topOffset(element) {
    let topPos = 0;

    while(element) {
      topPos += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }

    return topPos;
  }

  hideFauxSelect() {
    this.setState({
      highlighted: -1,
      showing: false
    });
  }

  render() {
    const { options } = this.props;
    let focus = false;

    function blurDropdown() {
      if(focus) {
        document.querySelector('.faux-select:focus').blur();
      }

      focus = !focus;
    }

    function focusButton(e) {
      let el = e.target.parentElement;

      while(el) {
        if(el.classList.contains('dropdown')) {
          el.className += ' dropdown--active';
          return el;
        } else {
          el = el.parentElement;
        }
      }
    }

    function blurButton(e) {
      let el = e.target.parentElement;

      while(el) {
        if(el.classList.contains('dropdown')) {
          el.classList.remove('dropdown--active');
          return el;
        } else {
          el = el.parentElement;
        }
      }
    }

    return(
      <div
        className="faux-select"
        tabIndex="0"
        onFocus={this.showFauxSelect}
      >
        <Dropdown
          ref="fauxSelect"
          onShow={(e) => this.showFauxSelect(e)}
          onHide={this.hideFauxSelect}
        >
          <DropdownTrigger
            className="faux-select__selected"
            onClick={blurDropdown}
          >
            {this.state.default}
          </DropdownTrigger>

          {this.props.store ?
            <this.props.store.validater>
            <DropdownContent>
              <ul
                className={`
                  faux-select__options dropdown__menu
                  ${this.props.noTooltip ? '' : 'has-tooltip'}
                `}
              >
                {options.map(
                  (key, i) => {
                  if(key.iamAction && key.iamResource) {
                    return (
                      <li
                        iamAction={key.iamAction}
                        iamResource={key.iamResource}
                        key={i}
                        className={`${key.helper ? 'has-tooltip' : ''}`}
                      >
                        <button
                          className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                          onClick={(e, i) => {this.clickOption(e, i)}}
                          data-label={key.title}
                          data-action={key.action}
                          tabIndex="0"
                          onFocus={(e) => {focusButton(e)}}
                          onBlur={(e) => {blurButton(e)}}
                          aria-labelledby={`${key.action}-tooltip`}
                          ref={`option-${i}`}
                        >
                          {key.title}

                          {key.subTitle &&
                            <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                          }
                        </button>

                        {this.renderTooltip(key)}
                      </li>
                    )
                  } else {
                    return (
                      <li
                        key={i}
                        className={`${key.helper ? 'has-tooltip' : ''}`}
                      >
                        <button
                          className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                          onClick={(e) => {this.clickOption(e, i)}}
                          data-label={key.title}
                          data-action={key.action}
                          tabIndex="0"
                          onFocus={(e) => {focusButton(e)}}
                          onBlur={(e) => {blurButton(e)}}
                          aria-labelledby={`${key.action}-tooltip`}
                          ref={`option-${i}`}
                        >
                          {key.title}

                          {key.subTitle &&
                            <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                          }
                        </button>

                        {this.renderTooltip(key)}
                      </li>
                    )
                  }
                })}
              </ul>
            </DropdownContent>
            </this.props.store.validater>
            :
            <DropdownContent>
              <ul
                className={`
                  faux-select__options dropdown__menu
                  ${this.props.noTooltip ? '' : 'has-tooltip'}
                `}
              >
                {options.map(
                  (key, i) =>
                  <li key={i} className={`${key.helper ? 'has-tooltip' : ''}`}>
                    <button
                      className={`faux-select__btn ${this.state.highlighted === i ? 'highlighted' : ''}`}
                      onClick={(e) => {this.clickOption(e, i)}}
                      data-label={key.title}
                      data-action={key.action}
                      tabIndex="0"
                      onFocus={(e) => {focusButton(e)}}
                      onBlur={(e) => {blurButton(e)}}
                      aria-labelledby={`${key.action}-tooltip`}
                      ref={`option-${i}`}
                    >
                      {key.title}

                      {key.subTitle &&
                        <span className="faux-select__subtitle" data-label={key.title}>{key.subTitle}</span>
                      }
                    </button>

                    {this.renderTooltip(key)}
                  </li>
                )}
              </ul>
            </DropdownContent>
          }
        </Dropdown>
      </div>
    );
  }
})

export default FauxSelect;



// WEBPACK FOOTER //
// ./src/app/components/Common/FauxSelect.js